import { Outlet } from 'react-router-dom';

export const PuckWrapper = () => {
  return (
    <div className="puck-pages-wrapper h-full relative">
      <Outlet />
    </div>
  );
};
